import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { EventMessage, EventType } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallbackComponent implements OnInit, OnDestroy {
  private readonly destroying$ = new Subject<void>();

  public constructor(private msalBroadcastService: MsalBroadcastService, private router: Router) {}

  public ngOnDestroy(): void {
    this.destroying$.next(undefined);
    this.destroying$.complete();
  }

  public ngOnInit(): void {
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.HANDLE_REDIRECT_END),
        takeUntil(this.destroying$)
      )
      .subscribe(() => {
        const route = sessionStorage.getItem('route');
        if (route && route !== '') {
          sessionStorage.removeItem('route');
          this.router.navigateByUrl(route);
        } else {
          this.router.navigate(['/']);
        }
      });
  }
}
